import React from 'react';
import HeroSection from '@/website/routes/_index/components/HeroSection.tsx';
import InsuranceLogoGallery from '@/website/routes/_index/components/InsuranceLogoGallery.tsx';
import CareOptionsSection from '@/website/routes/_index/components/CareOptionsSection.tsx';
import ServicesSection from '@/website/routes/_index/components/ServicesSection.tsx';

const IndexPage: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <InsuranceLogoGallery />
      <CareOptionsSection />
      <ServicesSection />
    </div>
  );
};

export default IndexPage;
